import React, { Component } from 'react';
import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Modal,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu
} from 'reactstrap';
import { Row } from 'reactstrap';
import './Header.scss';
import { connect } from 'react-redux';
import * as fabricCanvasActions from '../../redux/fabricCanvasActions';
import { saveOnlyIfDirtyAndCall } from '../../redux/projectSaveAndLoader';
import * as gaHelpers from '../../utilities/GAHelpers/GAHelpers';
import { bindActionCreators } from 'redux';
import UserGuide from '../../components/UserGuide/UserGuide';
import { Icons } from '../../utilities';
import { string } from '../../localization';
import * as Constants from '../../utilities/constants/Constants';
import ExternalLinkSaveProject from '../../components/ExternalLinkSaveProject';
import VanillaLogin from '../../components/VanillaDesign/VanillaLogin/VanillaLogin';
import {
  isProjectDirty,
  openLinkInCurrentTab,
  isModelPage
} from '../../utilities/HelperFunctions/HelperFunctions';
import PrinterDetails from '../../components/VanillaDesign/PrinterDetails/PrinterDetails';
import MessageDialogue from '../../components/MessageDialogue/MessageDialogue';
import MediaQuery from 'react-responsive';
import OrderSampleDetailsWindow from '../../components/PixelationWarning/OrderSampleDetailsWindow';
import * as homeActions from '../../redux/homeActions';
import * as pageControllerActions from '../../redux/pageControllerActions';
import DropDown from '../../UI/Dropdown/Dropdown';
import {
  resetActiveProject,
  shareProjectIsClicked
} from '../../redux/actions/multiWallHandler';

class Header extends Component {
  state = {
    shareOptions: [],
    socialMediaList: false,
    socialMediaUrl: '',
    disableClickForNextButton: false
  };

  componentDidMount() {
    this.setupBeforeUnloadListener();
    this.setState({
      shareOptions: [
        {
          name: string.FACEBOOK_KEY
          // icon_path: Icons.headerHelp,
          // alt: Constants.TOPBAR_ALT_KEY.FACEBOOK_KEY_ICON,
          // click: this.showHelperWindow
        },
        {
          name: string.TWITTER_KEY
          // icon_path: Icons.headerHelp,
          // alt: Constants.TOPBAR_ALT_KEY.FACEBOOK_KEY_ICON,
          // click: this.showHelperWindow
        },
        {
          name: string.PINTEREST_KEY
          // icon_path: Icons.headerHelp,
          // alt: Constants.TOPBAR_ALT_KEY.FACEBOOK_KEY_ICON,
          // click: this.showHelperWindow
        },
        {
          name: string.LINKED_KEY
          // icon_path: Icons.headerHelp,
          // alt: Constants.TOPBAR_ALT_KEY.FACEBOOK_KEY_ICON,
          // click: this.showHelperWindow
        },
        {
          name: string.EMAIL_KEY,
          // icon_path: Icons.headerHelp,
          // alt: Constants.TOPBAR_ALT_KEY.FACEBOOK_KEY_ICON,
          click: this.handleShareForEmail
        }
      ]
    });
  }

  styleForNextButton = () => {
    const { dispatchers } = this.props;
    if (dispatchers.pageControllerActions.shouldDisableNextButton()) {
      return 'next-icon next-icon-disable';
    }
    return 'next-icon';
  };

  imgSrcForNextButton = () => {
    const { dispatchers } = this.props;
    if (dispatchers.pageControllerActions.shouldDisableNextButton()) {
      return Icons.next_arrow_disable;
    }
    return Icons.next_arrow_white;
  };

  goToNextPage = () => {
    const { disableClickForNextButton } = this.state;
    if (!disableClickForNextButton) {
      this.setState({ disableClickForNextButton: true });
      const { page, isPresetSizePage, dispatchers } = this.props;

      if (page === Constants.SIZE_SELECTION_PAGE && !isPresetSizePage) {
        dispatchers.homeActions.settingsWallChange('custom');
      } else {
        dispatchers.pageControllerActions.goToNextPage();
      }
      this.setState({ disableClickForNextButton: false });
    }
  };

  handlePreviousPage = () => {
    const { dispatchers } = this.props;
    dispatchers.pageControllerActions.goToPrevPage();
    dispatchers.fabricCanvasActions.setIsThreeDViewLoaded(false);
  };

  setupBeforeUnloadListener = () => {
    window.addEventListener('beforeunload', ev =>
      this.doSomethingBeforeUnload(ev)
    );
  };

  doSomethingBeforeUnload = ev => {
    const { fabricCanvasReducer, page } = this.props;

    if (isProjectDirty(fabricCanvasReducer) && page === Constants.DESIGN_PAGE) {
      ev.preventDefault();
      ev.returnValue = 'Are you sure you want to close?';
    }
  };

  showVanillaLoginWindow = () => {
    const { vanillaLoginIsOpen, dispatchers } = this.props;
    dispatchers.fabricCanvasActions.showVanillaLoginDialogue(
      !vanillaLoginIsOpen
    );
    dispatchers.fabricCanvasActions.setWebLinkSaveIdentifier(
      Constants.DESIGN_KEY
    );
  };

  clicked = () => {};

  showHelperWindow = () => {
    const { dispatchers } = this.props;
    dispatchers.gaHelpers.saveGAEvent(
      Constants.GA_EVENT_ACTIONS.HIT_HELP_BUTTON
    );
    dispatchers.fabricCanvasActions.showHelperWindow(true);
    dispatchers.fabricCanvasActions.handleHelpCheckBox(false);
  };

  shareOptions = () => {
    const shareArray = [];
    const { shareOptions } = this.state;
    shareOptions.forEach(option => {
      const shareDictionary = {};
      shareDictionary.value = option.name;
      shareDictionary.label = option.name;
      shareArray.push(shareDictionary);
    });
  };

  sendShareGAEvenets = currentShareMedia => {
    const { dispatchers } = this.props;
    dispatchers.gaHelpers.sendShareGAEvents(currentShareMedia);
  };

  handleShareForSocialMedia = () => {
    const { dispatchers } = this.props;
    const { socialMediaUrl } = this.state;
    this.sendShareGAEvenets(socialMediaUrl);
    dispatchers.fabricCanvasActions.setIframe(true);
  };

  shareForEmail = () => {
    const { dispatchers } = this.props;
    this.sendShareGAEvenets('Email');
    dispatchers.fabricCanvasActions.showOrderSampleDetailsWindow(true);
  };

  handleShowOrderSample = () => {
    const { dispatchers } = this.props;
    dispatchers.fabricCanvasActions.showOrderSampleDetailsWindow(true);
  };

  shareProject = socialMedia => {
    const { dispatchers } = this.props;
    dispatchers.gaHelpers.shareProjectGA(socialMedia);
  };

  handleShareForDesign = socialMedia => {
    const { dispatchers } = this.props;
    const callback =
      socialMedia === Constants.EMAIL_KEY
        ? () => this.shareForEmail()
        : () => this.handleShareForSocialMedia();
    dispatchers.fabricCanvasActions.setWebLinkSaveIdentifier(
      Constants.DESIGN_KEY
    );
    dispatchers.fabricCanvasActions.setLoadingState(string.LOADING_KEY);
    dispatchers.saveOnlyIfDirtyAndCall().then(() => {
      callback();
      dispatchers.fabricCanvasActions.setShareMedium(null);
    });
  };

  handleSaveCancelled = () => {
    const { dispatchers } = this.props;
    dispatchers.fabricCanvasActions.setShareMedium(null);
    dispatchers.fabricCanvasActions.setSendPreviewWithLoupe(false);
    dispatchers.resetActiveProject();
  };

  handleSaveForDirty = socialMedia => {
    const { dispatchers, fabricCanvasReducer } = this.props;
    if (isProjectDirty(fabricCanvasReducer)) {
      const dict = {
        header: string.PRE_CHECK_SAVE_DIALOG_TITLE,
        description: string.PRE_CHECK_SAVE_DIALOG_MESSAGE,
        stringColor: Constants.DEFAULT_STRING_COLOR,
        onclick: () => this.handleShareForDesign(socialMedia),
        onCancel: () => this.handleSaveCancelled(),
        buttonTitles: { finish: string.OK_KEY, cancel: string.CANCEL_TEXT_KEY }
      };
      dispatchers.fabricCanvasActions.setMessageDialogParams(dict);
    } else if (socialMedia === Constants.EMAIL_KEY) {
      this.shareForEmail();
    } else {
      this.sendShareGAEvenets(socialMedia);
      dispatchers.fabricCanvasActions.setIframe(true);
    }
  };

  socialMediaShareHandler = indexArray => {
    const { dispatchers } = this.props;
    const index = indexArray.length > 1 ? indexArray[1] : 1;
    const socialMedia = this.shareItems()[indexArray[0]].id;
    dispatchers.shareProjectIsClicked(index);
    dispatchers.fabricCanvasActions.setShareMedium(socialMedia);
    if (socialMedia === Constants.EMAIL_KEY) {
      dispatchers.fabricCanvasActions.setSendPreviewWithLoupe(false);
    } else {
      this.setState({
        socialMediaUrl: socialMedia
      });
    }
    this.handleSaveForDirty(socialMedia);
  };

  handleShareForEmail = () => {
    this.setState(prevState => ({
      socialMediaList: !prevState.socialMediaList
    }));
  };

  handleProfile = () => {};

  closeIframe = () => {
    const { dispatchers } = this.props;
    dispatchers.fabricCanvasActions.setIframe(false);
  };

  showModal = () => {};

  canShowShare = () => {
    const { envData, storeData, page } = this.props;

    if (envData && !envData.view_only_preview_mode) {
      if (storeData && storeData.supportsShare) {
        if (envData.is_vanilla_designer) {
          return false;
        }
        if (!isModelPage(page)) {
          return true;
        }
      }
    }
    return false;
  };

  canShowSave = () => {
    const { envData, page } = this.props;
    if (envData) {
      if (
        envData.wallart_lite_external_link ||
        envData.is_vanilla_designer ||
        envData.view_only_preview_mode
      ) {
        return false;
      }
      if (!isModelPage(page)) {
        return true;
      }
    }
    return false;
  };

  handleSave = () => {
    const { dispatchers, fabricCanvasReducer, envData } = this.props;
    if (isProjectDirty(fabricCanvasReducer)) {
      dispatchers.gaHelpers.saveGAEvent(
        Constants.GA_EVENT_ACTIONS.SAVE_JOB_PROJECT
      );
      if (envData && envData.wallart_lite_web_link) {
        dispatchers.fabricCanvasActions.setWebLinkSaveIdentifier(
          Constants.DESIGN_KEY
        );
        dispatchers.fabricCanvasActions.setLoadingState(string.LOADING_KEY);
        dispatchers.saveOnlyIfDirtyAndCall();
      } else {
        dispatchers.fabricCanvasActions.saveIsClicked();
      }
    }
  };

  handleMywork = () => {
    const { envData } = this.props;
    if (envData.is_lite_patner) {
      openLinkInCurrentTab(Constants.MY_WORK);
    } else {
      this.showVanillaLoginWindow();
    }
  };

  canShowMyWorkButton = () => {
    const { envData, page } = this.props;
    if (envData) {
      return (
        envData.is_vanilla_designer &&
        !envData.view_only_preview_mode &&
        !isModelPage(page)
      );
    }
    return false;
  };

  canShowEnterButton = () => {
    const { envData, page } = this.props;
    if (envData) {
      if (
        !envData.is_lite_patner &&
        envData.is_vanilla_designer &&
        !envData.view_only_preview_mode &&
        page === Constants.DESIGN_PAGE
      ) {
        return true;
      }
    }
    return false;
  };

  canShowVanillaProfile = () => {
    const { envData } = this.props;
    if (envData) {
      if (
        envData.is_vanilla_designer &&
        envData.is_lite_patner &&
        !envData.view_only_preview_mode
      ) {
        return true;
      }
    }
    return false;
  };

  canShowProfile = () => {
    const { envData } = this.props;
    if (envData && this.getProfileUrl()) {
      if (envData.is_vanilla_designer || envData.view_only_preview_mode) {
        return false;
      }
      return true;
    }
    return false;
  };

  canShowHelp = () => {
    const { envData, page, storeData } = this.props;
    let hideHelp = false;
    if (storeData) {
      hideHelp = storeData.hideHelp;
    }
    if (envData) {
      if (!envData.view_only_preview_mode && !isModelPage(page) && !hideHelp) {
        return true;
      }
    }
    return false;
  };

  onAccountLogout = () => {
    const { envData } = this.props;
    let requestURL;
    if (envData.account_id != null) {
      requestURL = 'accounts/sign_out';
    } else {
      requestURL = '/sign_out';
    }
    window.open(requestURL, '_self');
  };

  getProfileUrl = () => {
    const { envData, storeData } = this.props;
    let storeIconImageView;
    let logoImageView;
    if (storeData) {
      if (
        storeData.licenseType === Constants.PREMIUM_TYPE &&
        storeData.iconUrl !== null
      ) {
        if (envData) {
          if (envData.account_id !== null) {
            storeIconImageView = envData.account_info.logo_url;
          } else {
            storeIconImageView = storeData.iconUrl;
          }
        }
        return storeIconImageView;
      }
      logoImageView = Icons.userIconBlue;
      return logoImageView;
    }
    return '';
  };

  getProfileName = () => {
    const { envData, storeData } = this.props;

    let logoName;
    if (envData) {
      if (envData.account_id) {
        logoName = envData.account_info.name;
      } else if (storeData) {
        if (
          storeData.licenseType === Constants.PREMIUM_TYPE &&
          storeData.companyName !== null
        ) {
          logoName = storeData.companyName;
        }
      }
      return logoName;
    }
    return '';
  };

  addPrinterHandler = () => {
    const { storeData } = this.props;
    return storeData && !storeData.hasLitePartnerPrinter;
  };

  headerItems = () => {
    const { envData, storeData } = this.props;

    return [
      {
        name: string.HELP_KEY,
        icon_path: Icons.headerHelp,
        validateButton: this.canShowHelp,
        alt: Constants.TOPBAR_ALT_KEY.HELP_ICON,
        click: this.showHelperWindow
      },
      {
        name: string.SHARE_KEY,
        icon_path: Icons.headerExport,
        validateButton: this.canShowShare,
        alt: Constants.TOPBAR_ALT_KEY.SHARE_ICON,
        click: this.handleShareForEmail
      },

      {
        name: string.SAVE_KEY,
        icon_path: Icons.headerSave,
        validateButton: this.canShowSave,
        alt: Constants.TOPBAR_ALT_KEY.SAVE_ICON,
        click: this.handleSave
      },
      {
        name: this.getProfileName(),
        icon_path: this.getProfileUrl(),
        validateButton: this.canShowProfile,
        alt: Constants.TOPBAR_ALT_KEY.PROFILE_ICON,
        click: this.handleProfile
      },

      {
        name: string.MY_WORK_KEY,
        icon_path: Icons.headerMywork,
        validateButton: this.canShowMyWorkButton,
        alt: Constants.TOPBAR_ALT_KEY.MYWORK_ICON,
        click: this.handleMywork
      },
      {
        name: envData ? envData.partner_name : null,
        icon_path: storeData ? storeData.productIconUrl : null,
        validateButton: this.canShowVanillaProfile,
        alt: Constants.TOPBAR_ALT_KEY.VANILLA_ACCOUNT_PROFILE_ICON,
        click: this.clicked
      },
      {
        name: string.ENTER_KEY,
        icon_path: Icons.userIconBlue,
        validateButton: this.canShowEnterButton,
        alt: Constants.TOPBAR_ALT_KEY.ENTER_ICON,
        click: this.showVanillaLoginWindow
      }
    ];
  };

  shareMainItems = () => [
    {
      id: 'facebook_connect',
      name: string.FACEBOOK_KEY,
      icon: Icons.facebook,
      alt: 'fb'
    },
    {
      id: 'twitter',
      name: string.TWITTER_KEY,
      icon: Icons.twitter,
      alt: 'tw'
    },
    {
      id: 'pinterest',
      name: string.PININTEREST_KEY,
      icon: Icons.pinterest,
      alt: 'pn'
    },
    {
      id: 'linked_in',
      name: string.LINKED_IN_KEY,
      icon: Icons.linkedin,
      alt: 'li'
    },
    {
      id: 'email',
      name: string.EMAIL_KEY,
      icon: Icons.mail,
      alt: 'em'
    }
  ];

  shareItems = () => {
    const { multiWallProjects } = this.props;
    const shareMainItems = this.shareMainItems();
    const isMultiwall = multiWallProjects.length > 1;
    if (isMultiwall) {
      shareMainItems.map(item => {
        item.options = [];
        multiWallProjects.map(wall => {
          item.options.push({
            id: wall.id,
            name: wall.name
          });
        });
      });
    }
    return shareMainItems;
  };

  getTopbarButton = item => {
    const { dispatchers, fabricCanvasReducer } = this.props;
    if (item.name === string.SHARE_KEY) {
      return (
        <div className='socialMediaDD'>
          <UncontrolledDropdown nav inNavbar>
            <a className='dropdown-toggle nav-link' data-toggle='dropdown'>
              <img alt={item.alt} src={item.icon_path} /> {item.name}{' '}
            </a>
            <DropDown
              items={this.shareItems()}
              clickEventHandler={this.socialMediaShareHandler}
            />
          </UncontrolledDropdown>
        </div>
      );
    }
    if (item.alt === Constants.TOPBAR_ALT_KEY.VANILLA_ACCOUNT_PROFILE_ICON) {
      return (
        <div className='socialMediaDD'>
          <UncontrolledDropdown nav inNavbar>
            <DropdownToggle nav caret>
              <img alt={item.alt} src={item.icon_path} /> {item.name}
            </DropdownToggle>
            <DropdownMenu right onClick={() => this.onAccountLogout()}>
              <div className='logoutVanilla'>{string.LOGOUT_KEY}</div>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      );
    }
    return (
      <NavItem>
        <div
          className={
            item.alt === Constants.TOPBAR_ALT_KEY.SAVE_ICON &&
            (!isProjectDirty(fabricCanvasReducer) ||
              dispatchers.pageControllerActions.doesProjectHasNoContents())
              ? ' disabled null-pointer-event'
              : null
          }
          id={`help-${item.alt}`}
        >
          <NavLink href='#' onClick={item.click}>
            <img alt={item.alt} src={item.icon_path} /> {item.name}
          </NavLink>
        </div>
      </NavItem>
    );
  };

  render() {
    const topbarItems = this.headerItems();
    const {
      type,
      sessionData,
      fabricCanvasReducer,
      storeData,
      envData,
      showOrderSampleDetailsWindow,
      vanillaLoginIsOpen,
      id,
      showIframe,
      page,
      dispatchers
    } = this.props;

    const { socialMediaUrl } = this.state;

    let headerName = null;
    if (envData) {
      if (envData.is_vanilla_designer) {
        headerName = string.WALL_POSTER_KEY;
      } else if (envData.category === Constants.GIFTWRAPS_CATEGORY) {
        headerName = string.GIFT_WRAPS_KEY;
      }
    }
    const topBarButtons = [];
    topbarItems.map(buttonDict => {
      if (buttonDict.validateButton !== null) {
        if (buttonDict.validateButton()) {
          topBarButtons.push(buttonDict);
        }
      } else {
        topBarButtons.push(buttonDict);
      }
    });

    const enterpriseAccount =
      envData && envData.enterprise_account ? envData.enterprise_account : null;
    const commonSetting =
      storeData && storeData.commonSetting ? storeData.commonSetting : null;
    const showLargerIcon =
      enterpriseAccount && commonSetting ? commonSetting.useLargerLogo : null;
    const topBarColor =
      commonSetting && !commonSetting.useDefaultColors
        ? `#${commonSetting.topBarColor}`
        : null;
    const logoAreaColor = commonSetting
      ? `#${commonSetting.logoAreaColor}`
      : null;
    const largeIconUrl = commonSetting ? commonSetting.largerLogoUrl : null;

    return (
      <>
        {showIframe && (
          <Modal
            className='modalContainer'
            isOpen={showIframe}
            backdrop={false}
          >
            <div>
              <div className='closeModalIcn'>
                <button
                  type='button'
                  className='closeButton'
                  onClick={this.closeIframe}
                >
                  <img src={Icons.close} className='closeModal' alt='close' />
                </button>
              </div>
              <iframe
                title='share'
                className='showIframe'
                frameBorder='0'
                src={`${socialMediaUrl}?project_id=${id}`}
              />
            </div>
          </Modal>
        )}
        <Navbar
          className={type}
          dark
          expand='md'
          style={{ backgroundColor: enterpriseAccount ? topBarColor : null }}
        >
          <MediaQuery query='(max-width: 767px)'>
            {dispatchers.pageControllerActions.canShowPreviousButton(type) ? (
              <button
                type='button'
                style={{ outline: 'none' }}
                className='prev-arrow'
                onClick={this.handlePreviousPage}
              >
                <img
                  src={Icons.prev_arrow_white}
                  style={{ width: '28px', height: '28px' }}
                  alt='prev'
                />
              </button>
            ) : null}
            {dispatchers.pageControllerActions.canShowNextButton() ? (
              <button
                type='button'
                style={{ outline: 'none' }}
                className={this.styleForNextButton()}
                onClick={this.goToNextPage}
              >
                <img
                  src={this.imgSrcForNextButton()}
                  style={{ width: '28px', height: '28px' }}
                  alt='next'
                />
              </button>
            ) : null}
          </MediaQuery>
          {sessionData === null ? (
            ''
          ) : (
            <NavbarBrand
              className={
                showLargerIcon && page === Constants.DESIGN_PAGE
                  ? 'show-larger-NavbarBrand'
                  : null
              }
            >
              <Row>
                <div
                  className={
                    showLargerIcon && page === Constants.DESIGN_PAGE
                      ? 'show-larger-icon'
                      : 'd-flex align-items-center'
                  }
                  style={{
                    backgroundColor:
                      enterpriseAccount &&
                      showLargerIcon &&
                      page === Constants.DESIGN_PAGE
                        ? logoAreaColor
                        : null
                  }}
                >
                  {/* <MediaQuery query='(max-width: 767px)'>
                    {page === Constants.DESIGN_PAGE ? (
                      <ResponsiveContent
                        handleSideBar={this.handleSideBar}
                        showSideBar={this.props.showSideBar}
                      />
                    ) : null}
                  </MediaQuery> */}

                  {enterpriseAccount &&
                  showLargerIcon &&
                  page === Constants.DESIGN_PAGE ? (
                    <img
                      className='larger-icon'
                      src={largeIconUrl}
                      alt='logo'
                      style={{ marginLeft: '20px' }}
                    />
                  ) : (
                    <img
                      src={
                        type === 'modal-navbar'
                          ? sessionData.store_icon
                          : Icons.hpPartnerHeaderLogo
                      }
                      alt='logo'
                      style={{ marginLeft: '20px' }}
                    />
                  )}
                  <div
                    style={{
                      marginRight: headerName ? '40px' : '0px'
                    }}
                    className='.tour-step-three logo-title'
                  >
                    {type === 'modal-navbar'
                      ? sessionData.company_name
                      : sessionData.title}
                  </div>
                </div>
                {/* Gift Wrap header */}
                {headerName !== null &&
                type === 'header-navbar' &&
                !envData.view_only_preview_mode ? (
                  <Row style={{ marginRight: '10px' }}>
                    <div className='header-seperator' />
                    <div className='application-header'>{headerName}</div>
                  </Row>
                ) : null}

                {/* Undo Redo */}
                <div>
                  {page === Constants.DESIGN_PAGE &&
                  envData &&
                  !envData.view_only_preview_mode ? (
                    <Nav
                      className={
                        type === 'header-navbar' ? 'd-flex nav-bar' : 'd-none'
                      }
                    >
                      <NavItem>
                        <NavLink
                          href='#'
                          onClick={() => {
                            if (fabricCanvasReducer.undoInstance.hasUndo()) {
                              fabricCanvasReducer.undoInstance.undo();
                            }
                          }}
                        >
                          <img
                            className='.tour-step-one'
                            alt='undo-icon'
                            src={
                              fabricCanvasReducer.undoInstance.hasUndo()
                                ? Icons.headerUndo
                                : Icons.headerUndoInactive
                            }
                            style={{
                              height: '15px',
                              width: '28px'
                            }}
                          />{' '}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          href='#'
                          onClick={() => {
                            if (fabricCanvasReducer.undoInstance.hasRedo()) {
                              fabricCanvasReducer.undoInstance.redo();
                            }
                          }}
                        >
                          <img
                            className='.tour-step-two'
                            alt='redo-icon'
                            src={
                              fabricCanvasReducer.undoInstance.hasRedo()
                                ? Icons.headerRedo
                                : Icons.headerRedoInactive
                            }
                            style={{ height: '15px', width: '28px' }}
                          />{' '}
                        </NavLink>
                      </NavItem>
                    </Nav>
                  ) : null}
                </div>
              </Row>
            </NavbarBrand>
          )}

          <MediaQuery query='(min-width: 767px)'>
            <Nav
              className={type === 'header-navbar' ? 'ml-auto' : 'd-none'}
              navbar
            >
              {topBarButtons.map(item => (
                <div key={item.alt}>{this.getTopbarButton(item)}</div>
              ))}
            </Nav>
          </MediaQuery>
        </Navbar>
        <MediaQuery query='(min-width: 767px)'>
          {envData && !envData.view_only_preview_mode ? <UserGuide /> : null}
        </MediaQuery>
        {this.addPrinterHandler() ? <PrinterDetails /> : null}
        {fabricCanvasReducer.webLinkSaveDialogue ? (
          <ExternalLinkSaveProject />
        ) : null}
        <MessageDialogue />
        {showOrderSampleDetailsWindow ? <OrderSampleDetailsWindow /> : null}
        <VanillaLogin
          isLoginOpen={vanillaLoginIsOpen}
          close={this.showVanillaLoginWindow}
        />
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    sessionData: state.modal.sessionData,
    fabricCanvasReducer: state.fabricCanvas,
    selectedProduct: state.home.selectedProduct,
    triggerProjectDirty: state.fabricCanvas.triggerProjectDirty,
    storeData: state.modal.storeData,
    envData: state.modal.envData,
    id: state.finalCheck.project.id,
    vanillaLoginIsOpen: state.fabricCanvas.vanillaLoginIsOpen,
    page: state.pageController.currentPageIndex,
    showIframe: state.fabricCanvas.showIframe,
    showOrderSampleDetailsWindow:
      state.fabricCanvas.showOrderSampleDetailsWindow,
    multiWallProjects: state.finalCheck.multiWallProjects,
    isPresetSizePage: state.pageController.isPresetSizePage,
    canvasType: state.home.canvasType,
    multiCanvasPopoverStatus: state.home.multiCanvasPopoverStatus,
    language: state.home.language,
    customWall: state.home.customWall,
    canvasWall: state.home.canvasWall,
    multiCanvas: state.home.multiCanvas
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch),
      gaHelpers: bindActionCreators(gaHelpers, dispatch),
      homeActions: bindActionCreators(homeActions, dispatch),
      pageControllerActions: bindActionCreators(
        pageControllerActions,
        dispatch
      ),
      saveOnlyIfDirtyAndCall: bindActionCreators(
        saveOnlyIfDirtyAndCall,
        dispatch
      ),
      shareProjectIsClicked: bindActionCreators(
        shareProjectIsClicked,
        dispatch
      ),
      resetActiveProject: bindActionCreators(resetActiveProject, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);
